module.exports = __webpack_public_path__ + "h5/img/mfe_07.64b735e4.jpeg";